import { z } from 'zod';
import { TopicStage } from './TopicStage';
export var audienceSegmentDefinition = z.object({
    keywords: z.array(z.string()).optional(),
    topics: z.array(z.string()).optional(),
    topicStage: z.nativeEnum(TopicStage).optional(),
    domains: z.array(z.string()).optional(),
    customSources: z.array(z.string()).optional(),
    buyerResearchStage: z.array(z.string()).optional(),
    locations: z.array(z.string()).optional(),
    activeSources: z.array(z.number()).length(2),
    businessEvents: z.array(z.string()),
    signalStrength: z.array(z.number()).length(2),
    hasSpotlight: z.boolean().optional(),
    minWebsiteActivity: z.number().optional(),
    minClicks: z.number().optional(),
    minLeads: z.number().optional(),
    minImpressions: z.number().optional(),
    mappingAccountCategories: z.array(z.string()),
    mappingAccountCategories2: z.array(z.string()),
    mappingAccountCategories3: z.array(z.string()),
});
export var defaultAudienceSegmentDefinition = {
    keywords: [],
    topics: [],
    topicStage: TopicStage.Unspecified,
    domains: [],
    customSources: [],
    businessEvents: [],
    buyerResearchStage: [],
    locations: [],
    activeSources: [0, 10],
    signalStrength: [0, 10],
    hasSpotlight: false,
    minWebsiteActivity: 0,
    minClicks: 0,
    minLeads: 0,
    minImpressions: 0,
    mappingAccountCategories: [],
    mappingAccountCategories2: [],
    mappingAccountCategories3: [],
};
export var audienceSegmentSchema = z.object({
    id: z.number(),
    name: z.string().min(3, { message: 'Must be 3 or more characters long' }),
    definition: audienceSegmentDefinition,
});
//# sourceMappingURL=AudienceSegment.js.map